import React from "react";
import { IconProps } from "./types";

function IconNoConversation(props: IconProps) {
  return (
    <svg
      width="80"
      height="80"
      viewBox="0 0 80 80"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g id="velaro_no-conversation-history 1">
        <path
          id="Vector"
          d="M20.9552 7.71042L60.472 8.99522C67.0624 9.20962 72.5584 14.2928 73.072 20.3584L75.6352 50.6496C76.1488 56.7152 71.5856 62.6496 65.1248 63.9696L26.3856 71.8784C17.016 73.792 8.38719 69.0144 7.71519 61.0832L4.36319 21.4864C3.69279 13.5568 11.3968 7.39682 20.9536 7.70722L20.9552 7.71042Z"
          fill="#EEF4FD"
        />
        <path
          id="Vector_2"
          d="M68.4848 30.272L24.6784 31.8672V57.5472L50.528 60.1152L61.8864 71.6816L65.0448 57.1376L70.4544 57.3072L68.4848 30.272Z"
          fill="black"
        />
        <path
          id="Vector_3"
          d="M70.1344 29.6224L26.3264 31.216V56.8976L52.1024 57.7024L61.6576 69.528L64.7248 58.0976L70.1344 58.2672V29.6224Z"
          fill="white"
        />
        <path
          id="Vector_4"
          d="M61.9504 70.9072L51.7888 58.3328L25.6864 57.5168V30.5984L70.7744 28.9568V58.9264L65.2112 58.752L61.9504 70.9072ZM26.9664 56.2768L52.416 57.072L61.3648 68.1472L64.2368 57.4416L69.4928 57.6064V30.2864L26.9648 31.8352V56.2784L26.9664 56.2768Z"
          fill="black"
        />
        <path
          id="Vector_5"
          d="M36.8496 47.16C38.2404 47.16 39.368 45.5884 39.368 43.6496C39.368 41.7109 38.2404 40.1392 36.8496 40.1392C35.4587 40.1392 34.3312 41.7109 34.3312 43.6496C34.3312 45.5884 35.4587 47.16 36.8496 47.16Z"
          fill="#629FF0"
        />
        <path
          id="Vector_6"
          d="M47.688 47.16C49.0789 47.16 50.2064 45.5884 50.2064 43.6496C50.2064 41.7109 49.0789 40.1392 47.688 40.1392C46.2971 40.1392 45.1696 41.7109 45.1696 43.6496C45.1696 45.5884 46.2971 47.16 47.688 47.16Z"
          fill="#629FF0"
        />
        <path
          id="Vector_7"
          d="M58.7232 47.16C60.114 47.16 61.2416 45.5884 61.2416 43.6496C61.2416 41.7109 60.114 40.1392 58.7232 40.1392C57.3323 40.1392 56.2048 41.7109 56.2048 43.6496C56.2048 45.5884 57.3323 47.16 58.7232 47.16Z"
          fill="#629FF0"
        />
        <path
          id="Vector_8"
          d="M26.7556 41.0686C34.317 39.5137 39.0338 31.3826 37.291 22.9071C35.5482 14.4317 28.0056 8.82152 20.4442 10.3764C12.8828 11.9313 8.1659 20.0625 9.90874 28.5379C11.6516 37.0133 19.1941 42.6235 26.7556 41.0686Z"
          fill="black"
        />
        <path
          id="Vector_9"
          d="M28.1708 40.0102C35.7322 38.4553 40.4491 30.3241 38.7063 21.8487C36.9634 13.3733 29.4209 7.76311 21.8595 9.318C14.2981 10.8729 9.58118 19.004 11.324 27.4795C13.0669 35.9549 20.6094 41.5651 28.1708 40.0102Z"
          fill="#3383EC"
        />
        <path
          id="Vector_10"
          d="M28.1708 40.0102C35.7322 38.4553 40.4491 30.3241 38.7063 21.8487C36.9634 13.3733 29.4209 7.76311 21.8595 9.318C14.2981 10.8729 9.58118 19.004 11.324 27.4795C13.0669 35.9549 20.6094 41.5651 28.1708 40.0102Z"
          fill="#AFCFF8"
        />
        <path
          id="Vector_11"
          d="M25.616 41.0128C22.6384 41.0128 19.6976 40.016 17.1216 38.1008C13.7936 35.6256 11.4752 31.9056 10.5968 27.6288C9.71681 23.3504 10.3792 19.0192 12.4608 15.4304C14.5584 11.8144 17.8432 9.38557 21.7104 8.59037C29.6608 6.95517 37.6112 12.8352 39.4336 21.6976C41.256 30.56 36.2704 39.1008 28.32 40.736C27.4208 40.92 26.5168 41.0128 25.616 41.0128ZM24.3904 9.80157C23.6016 9.80157 22.8064 9.87997 22.0096 10.0448C18.5632 10.7536 15.6272 12.9312 13.7456 16.176C11.8464 19.448 11.2464 23.4096 12.0512 27.3296C12.8576 31.2496 14.9728 34.6528 18.008 36.9104C21.0176 39.1488 24.5744 39.992 28.0208 39.2832C35.1696 37.8128 39.6368 30.0592 37.9792 21.9984C36.5056 14.8352 30.6832 9.80317 24.3888 9.80317L24.3904 9.80157Z"
          fill="black"
        />
        <path
          id="Vector_12"
          d="M24.3248 25.5376L19.9904 14.28L26.2544 12.9744L26.3408 25.168L24.3248 25.5376Z"
          fill="white"
        />
        <path
          id="Vector_13"
          d="M26.7149 32.9286C27.9717 32.6702 28.6986 31.0412 28.3386 29.2902C27.9785 27.5393 26.6678 26.3293 25.411 26.5877C24.1543 26.8462 23.4273 28.4751 23.7874 30.2261C24.1475 31.9771 25.4582 33.1871 26.7149 32.9286Z"
          fill="white"
        />
      </g>
    </svg>
  );
}

export default IconNoConversation;
